import type { FC } from "react";

import { SignInBlock } from "@unauthenticated/shared/components/SignInBlock";
import { SignInLayout } from "@unauthenticated/signupSignin/components";

interface Props {
  additionalAttributes?: any;
  ssoErrors?: string;
  authErrors?: string;
}

const SignInPage: FC<Props> = props => {
  return (
    <SignInLayout>
      <SignInBlock {...props} />
    </SignInLayout>
  );
};

export { SignInPage };
